import React, { useCallback } from 'react'
import { Box, Text } from '@usap/uicomponents'
import OrderItemWMO from './OrderItemWMO'
import OrderESPP from './OrderESPP'

import {
  Container,
} from './OrderWMO.css'

export default function Orders({
  isDesktop,
  config,
  items,
  orderStatus,
  navigateToRMA,
  orderDetails,
  setReturnDetailsData,
  setDisplayReturnDetails,
  creditStatus,
  returnRequestStatus,
  orderId,
  formatBrand,
  OpenChatHandler,
  coreConfig,
  history,
  isESPP,
  eSPPAmount,
  GTM,
  productProtectionPlan,
  isEppSubtext,
  unfoldedShippingConfig,
}) {
  return (
    <Container>
      <Box>
        {items.map((product, index) => (
          <OrderItemWMO
            key={index}
            config={config}
            orderDetails={orderDetails}
            itemDetails={orderDetails.items[index]}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            product={product}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            isDesktop={isDesktop}
            navigateToRMA={navigateToRMA}
            orderId={orderId}
            orderStatus={orderStatus}
            formatBrand={formatBrand}
            OpenChatHandler={OpenChatHandler}
            coreConfig={coreConfig}
            history={history}
            productProtectionPlan={productProtectionPlan}
            isEppSubtext={isEppSubtext}
            unfoldedShippingConfig={unfoldedShippingConfig}
          />
        ))}
      </Box>
      <Box>
        <OrderESPP
          isESPP={isESPP}
          eSPPAmount={eSPPAmount}
          GTM={GTM}
          orderDetails={orderDetails}
        />
      </Box>
    </Container>
  )
}
